// extracted by mini-css-extract-plugin
export default {"groupHeaderContainer":"group-header-module__groupHeaderContainer__pFBtTfd","groupHeaderContent":"group-header-module__groupHeaderContent__hN6zLbb"};